import * as React from "react"

const SvgBoltFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.99997 15.0001H5.89997C5.49997 15.0001 5.20414 14.8209 5.01247 14.4626C4.8208 14.1043 4.84164 13.7584 5.07497 13.4251L12.55 2.67509C12.7166 2.44175 12.9333 2.27925 13.2 2.18759C13.4666 2.09592 13.7416 2.10009 14.025 2.20009C14.3083 2.30009 14.5166 2.47509 14.65 2.72509C14.7833 2.97509 14.8333 3.24175 14.8 3.52509L14 10.0001H17.875C18.3083 10.0001 18.6125 10.1918 18.7875 10.5751C18.9625 10.9584 18.9083 11.3168 18.625 11.6501L10.4 21.5001C10.2166 21.7168 9.99164 21.8584 9.72497 21.9251C9.4583 21.9918 9.19997 21.9668 8.94997 21.8501C8.69997 21.7334 8.50414 21.5543 8.36247 21.3126C8.2208 21.0709 8.16664 20.8084 8.19997 20.5251L8.99997 15.0001Z" />
  </svg>
)
export default SvgBoltFilled
